export const LiveEndpoints = {
  lives: (slug: string) => `/rest/v1/live/live-started/${slug}`
}
